module.exports = __webpack_public_path__ + "static/media/bethel.15ce21e5.svg";